export const LEGAL_ACCEPTANCE_STATUS = Object.freeze({
  UNKNOWN: "unknown",
  ALLOWED: "allowed",
  REQUIRED: "required",
});

/**
 * A failed legal lookup is not a legal decision. Only a completed durable
 * query may route an authenticated user to the acceptance surface.
 */
export function legalAcceptanceStatusFromCheck({ accepted, error } = {}) {
  if (error) return LEGAL_ACCEPTANCE_STATUS.UNKNOWN;
  return accepted
    ? LEGAL_ACCEPTANCE_STATUS.ALLOWED
    : LEGAL_ACCEPTANCE_STATUS.REQUIRED;
}
